"use client";

import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Boxes, LogIn, UserPlus } from "lucide-react";
import LoadingSpinner from "@/components/ui/loading";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";

export default function Home() {
  const router = useRouter();
  const { user, isLoading } = useAuthRedirect(false);

  const handleLogin = () => {
    router.push("/login");
  };

  const handleSignUp = () => {
    router.push("/signup");
  };

  if (isLoading || user) {
    return <LoadingSpinner />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-screen p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center justify-center space-x-2">
            <Boxes className="h-8 w-8 text-primary" />
            <CardTitle className="text-3xl">Fabric Nextjs Base App</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-4">
            <p className="text-center text-muted-foreground">
              Sign in to access your dashboard or create a new account
            </p>
            <div className="space-y-2">
              <Button
                className="w-full"
                size="lg"
                onClick={handleLogin}
                variant="default"
              >
                <LogIn className="mr-2 h-5 w-5" />
                Sign In
              </Button>
              <Button
                className="w-full"
                size="lg"
                onClick={handleSignUp}
                variant="outline"
              >
                <UserPlus className="mr-2 h-5 w-5" />
                Create Account
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
